// Compact / exact formatting for large social counts (followers, following, wheels).
// Pure, dependency-free module so it can be unit-tested without pulling in the
// heavy helpers.js import chain (segmentTools -> Froala, etc.).

// < 1000 -> exact integer; >= 1000 -> rounded 1-decimal K/M/B (e.g. 1234567 -> "1.2M").
// Always returns a string; null / undefined / NaN / negative -> "0".
export const thousandFormatter = (input) => {
  const n = Number(input);
  if (!Number.isFinite(n) || n < 0) return "0";
  if (n < 1000) return `${Math.trunc(n)}`;
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n);
};

// Exact, thousands-separated value for tooltips / SR text alongside the compact form.
export const exactCountLabel = (input) => {
  const n = Number(input);
  if (!Number.isFinite(n) || n < 0) return "0";
  return new Intl.NumberFormat("en-US").format(Math.trunc(n));
};
